import ChangePassword from './ChangePassword.jsx';

export default ChangePassword;



// WEBPACK FOOTER //
// ./src/components/modules/change-password/index.js